import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../components/Loader'
import AdminCard from '../../components/AdminCard'

const Admins = () => {
    const { organization } = useParams()

    const [isLoading, setIsLoading] = useState(true)
    const [admins, setAdmins] = useState([])

    useEffect(() => {
        const getAdmins = async () => {
            try {
                setIsLoading(true)
                const response =await api.get(`/${organization}/admins`)
                console.log(response)
                if (response) {
                    setIsLoading(false)
                    setAdmins(response?.data)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response?.data.message)
            }
             finally{
                setIsLoading(false)
            }
        }
        getAdmins()
    }, [])
    return (
        <div>
                <h3 className="page-header-title">{organization}</h3><span>Admins</span>
            <div className="user-list">
                {isLoading && <Loader />}
                {
                    admins.length>0 && admins.map((admin)=>(
                        <AdminCard admin={admin} key={admin._id}/>
                    ))
                }
            </div>
        </div>
    )
}

export default Admins